import {
  Pressable, StyleSheet, Text, View,
} from 'react-native';
import { useState } from 'react';
import Colors from '../../constants/Colors';
import TickIcon from '../TickIcon';
import MultiLineGraph from '../../graphs/MultiLineGraph';
import { DateRange } from '../../redux/dateRangeSlice';
import TabButton from '../TabButton';

interface LineChartWidgetProps {
  range: DateRange;
  compareRange: DateRange;
  locationName: string;
}

const LineChartWidget = ({ locationName, range, compareRange }: LineChartWidgetProps) => {
  const [graphSelected, setGraphSelected] = useState<boolean>(true);
  const [happyScoreSelected, setHappyScoreSelected] = useState<boolean>(true);
  const [occupancySelected, setOccupancySelected] = useState<boolean>(true);
  const [capacitySelected, setCapacitySelected] = useState<boolean>(true);
  const [containerWidth, setContainerWidth] = useState<number>(100);

  const SelectLine = (title: string, selected: boolean, setSelected: () => void, color: string) => (
    <Pressable
      style={[styles.lineItem, selected && styles.lineItemSelected]}
      onPress={setSelected}
    >
      <View style={[styles.line, { backgroundColor: color }]} />
      <Text style={[styles.text, selected && styles.selectedText]}>{title}</Text>
      <View style={[styles.tickBox, selected && styles.tickBoxSelected]}>
        {selected && <TickIcon color={styles.tickBoxSelected.borderColor} />}
      </View>
    </Pressable>
  );

  return (<View
    style={[styles.container, { height: 24 + (containerWidth - 72) / 2 }]}
    onLayout={({ nativeEvent: { layout: { width } } }) => {
      if (width < 441) {
        setHappyScoreSelected(true);
        setOccupancySelected(true);
        setCapacitySelected(true);
      }
      setContainerWidth(width);
    }}
  >
    <View style={{ flexDirection: 'row' }}>
      <Text style={styles.locationName}>{locationName}</Text>
      <TabButton
        title='GRAPH'
        select={() => setGraphSelected(true)}
        selected={graphSelected}
      />
      <TabButton
        title='INSIGHTS'
        select={() => setGraphSelected(false)}
        selected={!graphSelected}
      />
    </View>
    {graphSelected
      ? <View style={{ flex: 1, justifyContent: 'space-between' }}>
        {containerWidth > 440 ? <View style={styles.lineItemsContainer}>
          {SelectLine('Happy Score', happyScoreSelected, () => setHappyScoreSelected(!happyScoreSelected), Colors.light.hereworksDarkBlue)}
          {SelectLine('Occupancy', occupancySelected, () => setOccupancySelected(!occupancySelected), Colors.light.hereworksPurple500)}
          {SelectLine('Capacity', capacitySelected, () => setCapacitySelected(!capacitySelected), Colors.light.hereworksGreen)}
        </View> : null}
        <MultiLineGraph
          title=''
          {...{ range, compareRange }}
          chartData={[happyScoreSelected ? [{
            index: 0, value: 20, date: '01/01/2024', color: Colors.light.hereworksDarkBlue,
          },
          {
            index: 1, value: 30, date: '01/01/2024', color: Colors.light.hereworksDarkBlue,
          },
          {
            index: 2, value: 20, date: '01/01/2024', color: Colors.light.hereworksDarkBlue,
          },
          {
            index: 3, value: 20, date: '01/01/2024', color: Colors.light.hereworksDarkBlue,
          },
          {
            index: 4, value: 20, date: '01/01/2024', color: Colors.light.hereworksDarkBlue,
          },
          ] : [], occupancySelected ? [
            {
              index: 0, value: 10, date: '01/01/2024', color: Colors.light.hereworksPurple500,
            },
            {
              index: 1, value: 20, date: '01/01/2024', color: Colors.light.hereworksPurple500,
            },
            {
              index: 2, value: 30, date: '01/01/2024', color: Colors.light.hereworksPurple500,
            },
            {
              index: 3, value: 40, date: '01/01/2024', color: Colors.light.hereworksPurple500,
            },
            {
              index: 4, value: 50, date: '01/01/2024', color: Colors.light.hereworksPurple500,
            },
          ] : [], capacitySelected ? [
            {
              index: 0, value: 40, date: '01/01/2024', color: Colors.light.hereworksGreen,
            },
            {
              index: 1, value: 40, date: '01/01/2024', color: Colors.light.hereworksGreen,
            },
            {
              index: 2, value: 40, date: '01/01/2024', color: Colors.light.hereworksGreen,
            },
            {
              index: 3, value: 40, date: '01/01/2024', color: Colors.light.hereworksGreen,
            },
            {
              index: 4, value: 40, date: '01/01/2024', color: Colors.light.hereworksGreen,
            },
          ] : []]}
        />
      </View> : <View style={styles.infoTab}>
        <Text>{'No Information Available'}</Text>
      </View>}
  </View>);
};

export default LineChartWidget;

const styles = StyleSheet.create({
  container: {
    borderRadius: 16,
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: Colors.light.hereworksWhite300,
    marginVertical: 12,
    padding: 16,
    justifyContent: 'center',
  },
  locationName: {
    flex: 1,
    fontSize: 18,
    fontFamily: 'Poppins_400Regular',
  },
  infoTab: {
    minHeight: 200,
    justifyContent: 'center',
    alignSelf: 'center',
    flex: 1,
  },
  line: {
    borderRadius: 2,
    width: 24,
    height: 2,
    marginStart: 8,
  },
  selectedText: {
    color: Colors.light.hereworksBlack500,
  },
  text: {
    color: Colors.light.hereworksBlack300,
    alignSelf: 'center',
    fontSize: 12,
    lineHeight: 10,
    marginStart: 6,
    marginEnd: 12,
    fontFamily: 'Poppins_400Regular',
  },
  lineItemsContainer: {
    paddingVertical: 8,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  lineItem: {
    backgroundColor: Colors.light.hereworksBlack50,
    borderColor: Colors.light.hereworksBlack100,
    borderWidth: 1.5,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    marginEnd: 8,
    flexDirection: 'row',
    height: 32,
    padding: 8,
  },
  lineItemSelected: {
    backgroundColor: Colors.light.hereworksWhite100,
    borderColor: Colors.light.hereworksBlue50,
  },
  tickBox: {
    width: 16,
    height: 16,
    borderRadius: 3,
    borderWidth: 1,
    marginEnd: 8,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: Colors.light.hereworksBlack100,
  },
  tickBoxSelected: {
    borderColor: Colors.light.hereworksBlue500,
  },
});
